import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import "@sourceflow-uk/job-search/dist/bundle.css";
import Search from "@/assets/Search.svg";
import JobSearch from "@sourceflow-uk/job-search";
import JobType from "@/../.sourceflow/jobs-contract_type.json";
import Location from "@/../.sourceflow/jobs-Location.json";
import Sectors from "@/../.sourceflow/jobs-Sectors.json";
import Consultants from "@/../.sourceflow/jobs-Consultants.json";
import { FormCheck, Stack } from "react-bootstrap";
import Hero from "@/components/Hero";
import { JobCard } from "@/components";

export default function JobsPage({title, canonical}) {

  const page = {
    title: {
      path: "jobs.hero.title",
      placeholder: "Jobs",
    },
    background: {
      path: "jobs.hero.background",
    },
  }

  return (
    <div>
      <SeoHead title={title} canonical={canonical} />
      <Hero background={page.background} title={page.title} />
      <div className={classes.feed}>
        <JobSearch
          options={{
            jobsUrl: "/jobs/",
            urlFilters: {
              mode: "active",
              jobCategories: [Sectors, Location, JobType, Consultants, ],
              changeURLOnFilterChange: true,
            },
            searchInput: {
              queryInput: true,
              locationInput: false,
            },
            searchFiltersOptions: {
              showResetSearchButton: true,
              topLevelCategoryOrder: ["Sector", "Location", "Contract Type", "Internal Jobs"],
              categorySort: {
                Sectors: { key: "name", direction: "asc" },
              },
              exclude: {Consultants: true},
              filterUnselectedElement: <FormCheck />,
              filterSelectedElement: <FormCheck checked />,
            },
            searchResults: ({ results }) =>
              results && (
                <>
                  <div className={classes.list}>
                    {results.map((job, index) => (
                      <div key={index} className="list-item">
                        <JobCard item={job.job} />
                      </div>
                    ))}
                  </div>
                </>
              )
          }}
          translations={{
            "filters.toggleButtonText": "",
            "searchResults.resultsTotalCount": "Search {{count}} Vacancies",
            "searchResults.buttonText": "View job",
            "input.placeHolder": "Search by keywords",
            "button.text": (
              <Stack className="flex-row align-items-center justify-content-center px-3" gap={2}>
                <Search />
              </Stack>
            ),
          }}
        />
      </div>
    </div>
  );
}

export async function getStaticProps({ }) {
  return {
    props: {
      title: "All jobs everywhere",
      canonical: "/jobs"
    },
  };
}